import RouteView from "../../../../Routes/RouteView";
import RiskNavOption, { defaultRoute } from "./RiskNavOption";

const RiskTemplates = ({ navoption, ModalAction })=>{
    return(
		<RouteView
			navoption={navoption}
			ModalAction={ModalAction}
			defaultRoute={defaultRoute}
		>
			{RiskNavOption}
		</RouteView>
    )
};

export default RiskTemplates